import { render, staticRenderFns } from "./ProductPanelInfo.vue?vue&type=template&id=b8047850&scoped=true&"
import script from "./ProductPanelInfo.vue?vue&type=script&lang=js&"
export * from "./ProductPanelInfo.vue?vue&type=script&lang=js&"
import style0 from "./ProductPanelInfo.vue?vue&type=style&index=0&id=b8047850&scoped=true&lang=sass&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b8047850",
  null
  
)

export default component.exports